import { ThemeOverride } from '@chakra-ui/react';

export const Drawer: ThemeOverride['components']['Drawer'] = {
  baseStyle: {
    dialog: {
      bg: 'black',
    },
  },
};
